export { SpaCategoryListTemplate } from './SpaCategoryListTemplate';
